import React, { PropsWithChildren } from 'react';

type TopItemType = PropsWithChildren;

export function TopItem({ children }: TopItemType) {
  return (
    <div className="main-navigation__top-item">
      <div className="main-navigation__top-linkbox">{children}</div>
    </div>
  );
}
